import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveService} from '../reactive-service.abstract';
import {UsernotificationModel} from './usernotification.model';
import {ChannelModel} from '../channel/channel.model';

@Injectable()
export class UsernotificationsApiService extends ReactiveService  {
    private baseUrl = environment.backEndUrlPrefix + '/' + 'db/user/profile/contact';

    constructor(private http: HttpClient) {
        super();
    }

    getAll(): Observable<UsernotificationModel[]> {
        return this.http.get<UsernotificationModel[]>(this.baseUrl);
    }

    updateGroup(ids: number[], data): Observable<ChannelModel[]> {
      return this.http.patch<ChannelModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
    }

    deleteGroup(ids: number[], password?: string): Observable<string> {
      const headers = new HttpHeaders().append('AuthPassword', password ? password : '');
      return this.http.delete<string>(this.baseUrl, {headers: headers, params: {id: ids.map(id => String(id))}});
    }

    getCsv(): Observable<Blob> {
      return  this.http.get<Blob>(this.baseUrl + '/csv', {responseType: 'blob' as 'json'});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UsernotificationModel[]> | Promise<UsernotificationModel[]> | UsernotificationModel[] {
        return this.getAll();
    }


}
